// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-icon[data-v-4699688c] {\n  color: #820000;\n  border: 0.1rem solid #820000;\n  width: 1.1rem;\n  height: 1.1rem;\n  padding: 2px;\n  border-radius: 100%;\n}\n.toggle-icon-level[data-v-4699688c] {\n  color: black;\n  width: 1.2rem;\n  height: 1.2rem;\n  padding: 2px;\n}\n.small-info-icon[data-v-4699688c] {\n  height: 0.85rem;\n  width: 0.85rem;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
